import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';
import { ThemeContext } from '@hig/theme-context';

var variants = Object.freeze({
  SIDE: "side",
  TOP: "top"
});

var availableVariants = Object.freeze(Object.values(variants));

function stylesheet(props, themeData) {
  var disabled = props.disabled,
      customStylesheet = props.stylesheet,
      variant = props.variant;

  var styles = {
    label: {
      fontSize: variant === "side" ? themeData["label.fontSize"] : themeData["label.top.fontSize"],
      fontFamily: themeData["label.fontFamily"],
      fontWeight: themeData["label.fontWeight"],
      lineHeight: themeData["label.lineHeight"],
      color: themeData["label.fontColor"],
      opacity: disabled ? themeData["colorScheme.opacity.disabled"] : "1.0"
    }
  };

  return customStylesheet ? customStylesheet(styles, props, themeData) : styles;
}

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = function (_Component) {
  _inherits(Label, _Component);

  function Label() {
    _classCallCheck(this, Label);

    return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
  }

  _createClass(Label, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          disabled = _props.disabled,
          customStylesheet = _props.stylesheet,
          variant = _props.variant,
          otherProps = _objectWithoutProperties(_props, ["children", "disabled", "stylesheet", "variant"]);

      var className = otherProps.className;


      return React.createElement(
        ThemeContext.Consumer,
        null,
        function (_ref) {
          var resolvedRoles = _ref.resolvedRoles;

          var styles = stylesheet({
            disabled: disabled,
            stylesheet: customStylesheet,
            variant: variant
          }, resolvedRoles);

          return (
            // eslint-disable-next-line jsx-a11y/label-has-for
            React.createElement(
              "label",
              _extends({}, otherProps, {
                className: cx([className, css(styles.label)])
              }),
              children
            )
          );
        }
      );
    }
  }]);

  return Label;
}(Component);

Label.propTypes = {
  /**
   * Content of the label, including the label text
   */
  children: PropTypes.node,
  /**
   * Dims label text, signifying the related input or control is disabled
   */
  disabled: PropTypes.bool,
  /**
   * Adds custom/overriding styles
   */
  stylesheet: PropTypes.func,
  /**
   * The visual variant of the label
   */
  variant: PropTypes.oneOf(availableVariants)
};
Label.defaultProps = {
  variant: variants.SIDE
};
Label.__docgenInfo = {
  "description": "",
  "displayName": "Label",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Content of the label, including the label text"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Dims label text, signifying the related input or control is disabled"
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Adds custom/overriding styles"
    },
    "variant": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "availableVariants"
      },
      "required": false,
      "description": "The visual variant of the label",
      "defaultValue": {
        "value": "variants.SIDE",
        "computed": true
      }
    }
  }
};

export default Label;
